import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Admin.css";
import NewEvent from "./eventos/newEvent/NewEvent";
import { useNavigate } from "react-router-dom";
import { clearAuth, getAuthToken, getTokenUserId } from "../../utils/auth";

const Admin = () => {
  const [events, setAdmin] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const token = getAuthToken();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    try {
      await axios.post(
        `https://www.euvoup14sports.com.br/api/logout`,
        {},
        config
      );
    } catch (error) {
      console.error("Erro ao salvar evento", error);
    }
    clearAuth();
  };
  const handleLogged = async () => {
    try {
      const userId = getTokenUserId(token);
      if (!userId) {
        throw new Error("Token sem identificação de usuário.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      await axios.post(
        `https://www.euvoup14sports.com.br/api/user/${userId}`,
        {},
        config
      );
    } catch (error) {
      handleLogout();
      clearAuth();
      navigate("/login");
    }
  };
  useEffect(() => {
    if (token) {
      handleLogged();
    } else {
      navigate("/login");
    }
  }, [token, navigate]);

  const fetchAdmin = async () => {
    try {
      const response = await axios.get(
        "https://www.euvoup14sports.com.br/api/event"
      );
      setAdmin(response.data || []);
    } catch (error) {
      if (
        error.response?.data?.message === "Unauthenticated." ||
        error.message === "Unauthenticated" ||
        error.response?.status === 401
      ) {
        handleLogout();
        clearAuth();
        navigate("/login", {
          state: {
            message: "Sua sessão expirou. Por favor, faça login novamente.",
          },
        });
      } else {
        // Handle other types of errors
        console.error("Erro de autenticação:", error);
      }
    }
  };

  useEffect(() => {
    fetchAdmin();
  }, []);

  const handleEventoClick = (id) => {
    setSelectedEventId(id);
    setShowModal(true);
  };

  const handleCloseModal = (refreshData = false) => {
    setShowModal(false);
    setSelectedEventId(null);

    if (refreshData) {
      fetchAdmin(); // This will be called when onClose(true) is passed from NewEvent
    }
  };

  const handleNovoEvento = () => {
    setSelectedEventId(null);
    setShowModal(true);
  };

  const handleExcluir = async (id, nome) => {
    const confirmacao = window.confirm(
      `Tem certeza que deseja excluir o evento: ${nome}?`
    );

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };

    if (confirmacao) {
      try {
        await axios.delete(
          `https://www.euvoup14sports.com.br/api/event/${id}`,
          config
        );
        fetchAdmin();
      } catch (error) {
        if (
          error.response?.data?.message === "Unauthenticated." ||
          error.message === "Unauthenticated" ||
          error.response?.status === 401
        ) {
          handleLogout();
          clearAuth();
          navigate("/login", {
            state: {
              message: "Sua sessão expirou. Por favor, faça login novamente.",
            },
          });
        } else {
          // Handle other types of errors
          console.error("Erro de autenticação:", error);
        }
      }
    }
  };

  return (
    <main className="admin-page">
      <header className="admin-page-header">
        <div>
          <span className="admin-page-eyebrow">Painel administrativo</span>
          <h1>Gerenciar eventos</h1>
          <p>Crie, edite e organize os eventos exibidos na página pública.</p>
        </div>

        <div className="admin-page-actions">
          <span className="admin-event-count">
            <strong>{events?.data?.length || 0}</strong>
            {events?.data?.length === 1 ? " evento" : " eventos"}
          </span>
          <button
            type="button"
            onClick={handleNovoEvento}
            className="admin-new-event-button"
          >
            <span aria-hidden="true">＋</span>
            Novo evento
          </button>
        </div>
      </header>

      <section className="admin-events-section" aria-labelledby="event-list-title">
        <div className="admin-section-heading">
          <div>
            <h2 id="event-list-title">Eventos cadastrados</h2>
            <p>Selecione um card para editar suas informações.</p>
          </div>
        </div>

        {events?.data?.length > 0 ? (
          <div className="admin-events-grid">
            {events.data.map((event) => (
              <article className="admin-event-card" key={event.id}>
                <button
                  type="button"
                  className="admin-event-main"
                  onClick={() => handleEventoClick(event.id)}
                  aria-label={`Editar evento ${event.title}`}
                >
                  <div className="admin-event-media">
                    {event.full_path ? (
                      <img src={event.full_path} alt="" />
                    ) : (
                      <div className="admin-event-placeholder" aria-hidden="true">
                        P14
                      </div>
                    )}
                    <span className="admin-event-edit-hint">Editar evento</span>
                  </div>

                  <div className="admin-event-content">
                    <span className="admin-event-label">Evento</span>
                    <h3>{event.title}</h3>
                    <p>
                      <span aria-hidden="true">◷</span>
                      {event.date_start || "Data não informada"}
                    </p>
                  </div>
                </button>

                <div className="admin-event-footer">
                  <button
                    type="button"
                    className="admin-event-delete"
                    onClick={() => handleExcluir(event.id, event.title)}
                    aria-label={`Excluir evento ${event.title}`}
                  >
                    <span aria-hidden="true">⌫</span>
                    Excluir
                  </button>
                  <button
                    type="button"
                    className="admin-event-edit"
                    onClick={() => handleEventoClick(event.id)}
                  >
                    Editar
                    <span aria-hidden="true">→</span>
                  </button>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="admin-empty-state">
            <span className="admin-empty-icon" aria-hidden="true">＋</span>
            <h3>Nenhum evento disponível</h3>
            <p>Cadastre o primeiro evento para começar.</p>
            <button type="button" onClick={handleNovoEvento}>
              Criar evento
            </button>
          </div>
        )}
      </section>

      {showModal && (
        <NewEvent id={selectedEventId} onClose={handleCloseModal} />
      )}
    </main>
  );
};

export default Admin;
